"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Search = function Search(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#000" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    scale: width / 20,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.883 18.32a.422.422 0 0 1 .117.313c0 .13-.04.247-.117.351l-.899.86a.486.486 0 0 1-.351.156.371.371 0 0 1-.313-.156l-4.765-4.727a.52.52 0 0 1-.118-.312v-.547a8.392 8.392 0 0 1-2.46 1.465 7.856 7.856 0 0 1-2.852.527c-1.484 0-2.845-.365-4.082-1.094a8.209 8.209 0 0 1-2.95-2.949C.366 10.97 0 9.609 0 8.125S.365 5.28 1.094 4.043a8.209 8.209 0 0 1 2.949-2.95C5.28.366 6.641 0 8.125 0s2.845.365 4.082 1.094a8.209 8.209 0 0 1 2.95 2.949c.728 1.237 1.093 2.598 1.093 4.082 0 .99-.176 1.94-.527 2.852a8.392 8.392 0 0 1-1.465 2.46h.547c.13 0 .234.04.312.118l4.766 4.765zM8.125 14.375c1.12 0 2.161-.28 3.125-.84a6.206 6.206 0 0 0 2.285-2.285c.56-.964.84-2.005.84-3.125s-.28-2.161-.84-3.125a6.206 6.206 0 0 0-2.285-2.285 6.114 6.114 0 0 0-3.125-.84c-1.12 0-2.161.28-3.125.84A6.206 6.206 0 0 0 2.715 5a6.114 6.114 0 0 0-.84 3.125c0 1.12.28 2.161.84 3.125A6.206 6.206 0 0 0 5 13.535c.964.56 2.005.84 3.125.84z",
    id: "search"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#search"
  }));
};

var _default = Search;
exports["default"] = _default;
module.exports = exports["default"];